import Vue from 'vue'
import App from './App.vue'
import router from './router'
import instance from './axios.config'
import store from './store'
import "swiper/css/swiper.min.css"
import "./assets/css/animate.min.css"
import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/nutui.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueWechatTitle from 'vue-wechat-title';

/*import VConsole from 'vconsole';
new VConsole();*/

Vue.use(VueWechatTitle)

Vue.use(Vant)
NutUI.install(Vue)
Vue.config.productionTip = false
if (!localStorage.getItem('userId')) {
  router.push('/login')
}

Vue.prototype.$ajax = instance

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  Vue.prototype.upFileUrl = localStorage.getItem("upFileUrl");
/*  if (localStorage.getItem("isSafePwd") === "false" && to.name !== "editPass"&& to.name !== "login") {
    next("/editPass")
    return
  }*/
  if (!token && to.path !== "/login") {
    next("/login")
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
